const { Core, onPlyrLoad, Utils } = Global;

if (!customElements.get('background-video')) {
  customElements.define('background-video', class extends Core {
    elements = {
      $: ['template', 'content']
    }

    propTypes = {
      'desktop-only': Boolean
    }

    inited = false;

    render() {
      if (this.prop('desktop-only') && document.documentElement.clientWidth <= 992) {
        this.remove();
        return;
      }

      this._handlePlaying = this._handlePlaying.bind(this);
      this._handleNativeReady = this._handleNativeReady.bind(this);
      this._handleNativeError = this._handleNativeError.bind(this);
      this._initPlayer = this._initPlayer.bind(this);

      const templateRoot = this.$('template')?.content?.firstElementChild;

      if (!templateRoot) return;

      this.isNativeVideo = templateRoot.tagName === 'VIDEO';

      if (this.isNativeVideo) {
        this._initNativeVideo();
      } else {
        onPlyrLoad(() => {
          if (!this._observer) {
            this._observer = new IntersectionObserver(this._initPlayer, {
              rootMargin: '150px 0px'
            });
          }
          this._observer.observe(this);
        });
      }
    }

    _initNativeVideo() {
      if (this.player) return;

      this._initContainer();

      this.player = this.playerContainer;
      this.player.muted = true;
      this.player.defaultMuted = true;
      this.player.autoplay = true;
      this.player.loop = true;
      this.player.playsInline = true;
      this.player.setAttribute('muted', '');
      this.player.setAttribute('autoplay', '');
      this.player.setAttribute('loop', '');
      this.player.setAttribute('playsinline', '');

      this.player.addEventListener('playing', this._handlePlaying);
      this.player.addEventListener('loadeddata', this._handleNativeReady);
      this.player.addEventListener('canplay', this._handleNativeReady);
      this.player.addEventListener('error', this._handleNativeError);

      this._tryPlay();
      this._retryTimer = setTimeout(() => this._tryPlay(), 1200);
    }

    _initPlayer([entry]) {
      if (!entry.isIntersecting) {
        this.player?.pause?.();
        return;
      }

      if (this.player) {
        this.player.play?.();
        return;
      }

      this._initContainer();

      this.player = new window.Plyr(this.playerContainer, {
        muted: true,
        controls: [],
        clickToPlay: false,
        fullscreen: false,
        settings: []
      });

      this.player.loop = true;

      if (typeof this.player.setVolume !== 'undefined') {
        this.player.setVolume(0);
      }

      this.player.once('ready', () => this.player.play());
      this.prevTime && this.player.on('play', this._forwardToPrevTime.bind(this));
      this.player.on('ended', this.player.restart);
      this.player.on('playing', this._handlePlaying);

      this.player.once('error', () => {
        console.warn('Background embed failed to load');
      });
    }

    _initContainer() {
      this.playerContainer = this.$('template').content.cloneNode(true).firstElementChild;
      this.$('content').appendChild(this.playerContainer);
    }

    _tryPlay() {
      if (!this.player || !this.isNativeVideo) return;

      const promise = this.player.play();

      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {});
      }
    }

    _handleNativeReady() {
      this._tryPlay();
      this._handlePlaying();
    }

    _handleNativeError() {
      console.warn('Background video failed to load');
    }

    _handlePlaying() {
      if (!this.inited) {
        this.inited = true;
        Utils.$state(this, 'inited');
      }
    }

    destroy() {
      if (this._retryTimer) {
        clearTimeout(this._retryTimer);
      }

      if (this.isNativeVideo && this.player) {
        this.player.removeEventListener('playing', this._handlePlaying);
        this.player.removeEventListener('loadeddata', this._handleNativeReady);
        this.player.removeEventListener('canplay', this._handleNativeReady);
        this.player.removeEventListener('error', this._handleNativeError);
      }

      if (this.player && !this.isNativeVideo) {
        this.player.destroy?.();
      }

      if (this.playerContainer) {
        this.playerContainer.remove?.();
      }

      if (this._observer) {
        this._observer.disconnect();
      }

      this.player = null;
      this.playerContainer = null;
      this.inited = false;
      Utils.$state(this, 'inited', false);
    }
  });
}